import React from "react"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import { Hidden } from "@material-ui/core"

const AboutMe = props => {
  const years = new Date().getFullYear() - new Date(2016, 10, 1).getFullYear()

  return (
    <React.Fragment>
      <Box
        justifyContent="center"
        display="flex"
        alignItems="center"
        flex={1}
        flexDirection="column"
        minHeight="100vh"
        style={{ backgroundColor: "#fff" }}
      >
        <Hidden mdDown>
          <Typography
            variant="h1"
            style={{
              fontSize: 56,
              marginTop: 10,
              textAlign: "center",
              color: "#757575",
            }}
          >
            {"ABOUT ME"}
          </Typography>

          <Box
            style={{
              width: 100,
              height: 3,
              backgroundColor: "#9e9e9e",
              marginTop: 10,
            }}
          />

          <Typography
            variant="h2"
            style={{
              fontSize: 26,
              marginTop: 30,
              textAlign: "center",
              color: "#757575",
              maxWidth: 800,
              lineHeight: "40px",
              marginLeft: 50,
              marginRight: 50,
            }}
          >
            {
              "I'm a full-stack developer specialized in Web, Progressive Web Apps, Mobile (iOS/Android) projects and scalable backend services."
            }
            <br />
            {"I have " +
              years +
              "+ years of experience as a software engineer, and have worked at both startups and large organizations."}
            <br />
            {
              "I'm experienced with javaScript libraries/frameworks like React, NextJS, React Native and Java. I'm a huge fan of React Native and love to develop mobile apps."
            }
            <br />
            {
              "Feel free to follow my blog and connect with me through social media links."
            }
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 28,
              marginTop: 30,
              maxWidth: 300,
            }}
          >
            <img
              src={"/signature.png"}
              width={"80%"}
              style={{ margin: 0, width: "80%" }}
              alt="signature-samiya"
              title="Signature"
            />
          </Box>
        </Hidden>
        <Hidden lgUp>
          <Typography
            variant="h1"
            style={{
              fontSize: 30,
              marginTop: 10,
              textAlign: "center",
              color: "#757575",
            }}
          >
            {"ABOUT ME"}
          </Typography>

          <Box
            style={{
              width: 50,
              height: 3,
              backgroundColor: "#9e9e9e",
              marginTop: 10,
            }}
          />

          <Typography
            variant="body2"
            style={{
              fontSize: 18,
              marginTop: 30,
              textAlign: "center",
              color: "#9e9e9e",
              maxWidth: 800,
              lineHeight: "30px",
              marginLeft: 50,
              marginRight: 50,
            }}
          >
            {
              "I'm a full-stack developer specialized in Web, Progressive Web Apps, Mobile (iOS/Android) projects and scalable backend services."
            }
            <br />
            {"I have " +
              years +
              "+ years of experience as a software engineer, and have worked at both startups and large organizations."}
            <br />
            {
              "I'm experienced with javaScript libraries/frameworks like React, NextJS, React Native and Java. I'm a huge fan of React Native and love to develop mobile apps."
            }
            <br />
            {
              "Feel free to follow my blog and connect with me through social media links."
            }
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 28,
              marginTop: 30,
              maxWidth: 200,
            }}
          >
            <img
              src={"/signature.png"}
              width={"80%"}
              style={{ margin: 0, width: "80%" }}
              alt="signature-samiya-mobile"
              title="Signature"
            />
          </Box>
        </Hidden>
      </Box>
    </React.Fragment>
  )
}

export default AboutMe
